
import Vue from 'vue'

const actions = {

    async DashboardAdmin(_, filterRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post("dashboard/dashboard-admin", filterRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listDashboardAdmin = result.data.result;

                return listDashboardAdmin;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list dashboards: [${ex}]`
            };
        }
    },
}

export default {
    namespaced: true,
    actions
}